export const exitFullscreen = (document: Document) => {
  if ((document as any).webkitExitFullscreen) {
    //Returns a Promise: false
    (document as any).webkitExitFullscreen();
    return Promise.resolve();
  } else {
    if ((document as any).exitFullscreen) {
      const res = document.exitFullscreen();
      if (res) {
        return res;
      }
      return Promise.resolve();
    } else {
      return Promise.reject("No fullscreen API");
    }
  }
};
